import {chain} from 'lodash';
import React, {FC} from 'react';
import styled from 'styled-components';

import {ChromelessButton} from '../../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {emojiMap} from '../../../../services/emojis/emojis';
import {SkinTonesEnum} from '../../../../services/emojis/emojiTypes';
import {Emoji} from '../../emoji/emoji';

/*
 * Props.
 */

export interface EmojiDropdownSkinTonesProps {
  skinTone: SkinTonesEnum;
  onSkinToneSelect: (arg: SkinTonesEnum) => void;
}

/*
 * Style.
 */

const StyledTonesDiv = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-column-gap: 10px;
  align-items: center;
  margin: 0 16px;
`;

const StyledToneDiv = styled(ChromelessButton)`
  padding: 3px;
  border-radius: 4px;

  &:hover {
    background-color: ${(p) => p.theme.alphas.gray10};
  }
`;

/*
 * Component.
 */

export const EmojiDropdownSkinTones: FC<EmojiDropdownSkinTonesProps> = (props) => {
  // Render each skin tone button.
  const skinTonesRenders = chain(SkinTonesEnum)
    .filter((s) => Number.isInteger(Number(s)))
    .map((s) => renderSkinTone(props, s))
    .value();

  // Wrap and return.
  return <StyledTonesDiv>{skinTonesRenders}</StyledTonesDiv>;
};

const thumbsUpEmoji = emojiMap['+1'];
function renderSkinTone(props: EmojiDropdownSkinTonesProps, skinTone: SkinTonesEnum) {
  return (
    <StyledToneDiv key={skinTone} onClick={() => props.onSkinToneSelect(skinTone)}>
      <Emoji useSheet emoji={thumbsUpEmoji} skinTone={skinTone} size={24} />
    </StyledToneDiv>
  );
}
